import React, { useEffect } from "react";
import { Nav } from "./Nav";
import { Footer } from "./Footer";
import "../../enterprise-2.css";
import "../../enterprise-2-apple.css";

/**
 * MarketingLayout wraps every marketing route. The `.e2` class scopes
 * every marketing-only CSS variable and selector so nothing here can bleed
 * into the audit respondent flow or admin surfaces.
 */
export function MarketingLayout({ children, active, title, description, nav, side = "enterprise" }) {
  useEffect(() => {
    if (title) document.title = title;
    if (description) {
      let m = document.querySelector('meta[name="description"]');
      if (!m) {
        m = document.createElement("meta");
        m.setAttribute("name", "description");
        document.head.appendChild(m);
      }
      m.setAttribute("content", description);
    }
  }, [title, description]);

  return (
    <div className="e2" data-testid="e2-layout">
      <Nav active={active} {...(nav || {})} />
      <main>{children}</main>
      <Footer side={side} />
    </div>
  );
}
